module.exports = __webpack_public_path__ + "img/0S6A9963.a57f0ec9.jpg";